import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CLINIC_IMG = "https://images.unsplash.com/photo-1761971974992-6df33df97c3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxyZWhhYmlsaXRhdGlvbiUyMGd5bXxlbnwwfHx8fDE3ODM2NjM2OTh8MA&ixlib=rb-4.1.0&q=85";

export default function EmpathySection() {
  return (
    <section className="bg-brand-cream/50">
      <div className="container-wide py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="eyebrow mb-3">Why this matters</div>
          <h2 className="text-3xl md:text-5xl font-heading leading-[1.05]">
            When pain or limited movement starts affecting your life, you need more than temporary relief.
          </h2>
          <p className="text-brand-ink2 mt-5">
            Patients come to us after pain that keeps returning, injuries that aren't improving, surgery, difficulty walking, sports setbacks, neurological conditions, or previous treatment that fell short. We start by understanding your condition, movement, symptoms, functional limitations and personal goals — then we build a plan around you.
          </p>
          <div className="mt-6 flex gap-3">
            <Link to="/services" className="btn-primary">Explore Services <ArrowRight size={16} /></Link>
            <Link to="/first-visit" className="btn-outline">What to expect</Link>
          </div>
        </div>
        <div className="rounded-[2rem] overflow-hidden aspect-[4/3] bg-white">
          <img src={CLINIC_IMG} alt="Rehabilitation gym at Physio Hyve" className="w-full h-full object-cover" />
        </div>
      </div>
    </section>
  );
}
